module.exports = __webpack_public_path__ + "static/media/monkaHmm.5eb95ce5.png";